var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1),_c('b-toaster',{attrs:{"name":"toast-alertas-toaster","position":"b-toaster-top-right"}}),_c('ToastAlertas')],1)}
var staticRenderFns = []

export { render, staticRenderFns }